import '@angular/localize/init';

// Dragula required global
(window as any).global = window;
